/**
 * Перечень врачей на главной странице
 *
 * @param {Object} params
 * @param {String} params.linkServiceFavoriteDoctors - ссылка на выбранную специализацию врача
 * @param {String} params.listFavoriteDoctors - список врачей выбранной специализации
 * @param {String} params.idServiceFavoriteDoctors - id выбранного списка
 * @param {String} params.classActive - класс для отображения активной специализации
 */
$.fn.doctorsListMain = function (params) {

    const $self = $(this);
    const linkServiceFavoriteDoctors = params.linkServiceFavoriteDoctors;
    const listFavoriteDoctors = params.listFavoriteDoctors;
    const idServiceFavoriteDoctors = params.idServiceFavoriteDoctors;
    const classActive = params.classActive;

    $self.on('click', linkServiceFavoriteDoctors, function() {

        let listDoctors = $(this).attr(idServiceFavoriteDoctors);

        $self.find($(linkServiceFavoriteDoctors)).each(function() {
            $(this).removeClass(classActive);
        });

        $self.find($(listFavoriteDoctors)).each(function() {
            $(this).removeClass(classActive);
        });

        $(this).addClass(classActive);
        $(listDoctors).addClass(classActive);
    });

    return this;
};

// инициализация
const init = function () {
    $('#doctors-list-main').doctorsListMain({
        linkServiceFavoriteDoctors: '.js-link-service-favorite-doctors',
        listFavoriteDoctors: '.js-list-favorite-doctors',
        idServiceFavoriteDoctors: 'data-id-service-favorite-doctors',
        classActive: 'active',
    });
};

if ($('#doctors-list-main').length > 0) {
    init();
}
